import React from 'react';

import ErroX from  '../../components/Erro'
import {get_NoiteDia} from '../../components/NoiteDia'

import SVG_b_404 from '../../assets/images/404b@2x.svg';
import SVG_w_404 from '../../assets/images/404w@2x.svg';



//function Erro404() {
function Erro404 () {
    const xSVGwb = {
    "w": SVG_w_404,
    "b": SVG_b_404
    }
    const root = document.documentElement;
    let xSVG;
    const modo_noite = get_NoiteDia()

    if (modo_noite) {
        //-dj//console.log("mudando para noite")
        root.style.setProperty("--color-background-erro", "var(--color-background-erro-black)")
        root.style.setProperty("--color-text", "var(--color-text-black)")
        xSVG = xSVGwb.w
    } else {
        //-dj//console.log("mudando para dia")
        root.style.setProperty("--color-background-erro", "var(--color-background-erro-white)")
        root.style.setProperty("--color-text", "var(--color-text-white)")
        xSVG = xSVGwb.b
    }

    return (
        <ErroX
          xSVG={xSVG} //{"w":erroSVG_w,"b":erroSVG_b}
          text_aviso="OOPS!"
          text_description="Não encontrei o que você pediu, tente novamente ou tente ir para a página inicial"
          text_btn="Me leve de volta ao Início"
        />
    );
}

export default Erro404;
